'use client';

import { Leva } from 'leva';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { DarkTheme } from '@/ui/themes';

const isDevelopment = process.env.NODE_ENV === 'development';

export const LevaStyles = ({ children }: { children?: ReactNode }) => {
  const { accent } = DarkTheme;
  // The /sky playground pages expose their tuning panel even in production
  // (Vercel previews are production builds).
  const pathname = usePathname();
  const isSkyPlayground = pathname?.startsWith('/sky') ?? false;

  return (
    <>
      <Leva
        theme={{
          colors: {
            elevation1: 'rgba(0, 0, 0, 0.2)',
            elevation2: 'rgba(0, 0, 0, 0)',
            elevation3: 'rgba(255, 255, 255, 0.1)',
            accent1: accent,
            accent2: accent,
            accent3: accent,
            folderTextColor: 'white',
            highlight1: 'rgba(255, 255, 255, 0.5)',
            highlight2: 'rgba(255, 255, 255, 0.5)',
            highlight3: 'rgba(255, 255, 255, 0.5)',
          },
          fontSizes: {
            toolTip: '12rem',
          },
          shadows: {
            level1: 'inset 0 0 2px rgba(255, 255, 255, 0.5)',
          },
        }}
        hidden={!isDevelopment && !isSkyPlayground}
      />

      {children}
    </>
  );
};
